import { ExpressionResolverFn } from "../core/types";

import { differentThan } from "./resolvers/differentThan";
import { isEmptyResolver } from "./resolvers/isEmpty";
import { regexValidator } from "./resolvers/regex";
import { roleResolver } from "./resolvers/role";

const expressionsMap = new Map<string, ExpressionResolverFn>();

expressionsMap.set("regex", regexValidator);
expressionsMap.set("different-than", differentThan);
expressionsMap.set("is-empty", isEmptyResolver);
expressionsMap.set("role", roleResolver);

export const getExpressionResolver = (type: string) => {
  const resolverFn = expressionsMap.get(type);
  return resolverFn;
};
